import {useI18n} from '@logistics-frontend/core/i18n'
import React, {useMemo} from 'react'

import {ZonalPrice} from '../../types'
import {formatWhiteListItemsProp, getFromTransferDetails, getMinFromIntervals, getPaidWaiting} from '../../utils'
import {DetailsList} from '../details-list'

const getTransferMinimalCost = getFromTransferDetails(['minimal'])
const getTransferLandingCost = getFromTransferDetails(['once'])
const getTransferIncludedWaiting = getFromTransferDetails(['waiting_included'])
const getTransferIncludedUnits = (field: string) => (transferDetails: any) => {
  const intervals = getFromTransferDetails([field], [])(transferDetails)
  return getMinFromIntervals(intervals)
}
const getTransferIncludedDistance = getTransferIncludedUnits('distance_price_intervals')
const getTransferIncludedTime = getTransferIncludedUnits('time_price_intervals')

type Props = {
  transferDetails: ZonalPrice
  currencySign: string
  title?: string
}

const TransferPickup: React.FC<Props> = ({currencySign, transferDetails, title}) => {
  const t = useI18n()

  const items = useMemo(() => {
    return formatWhiteListItemsProp([
      {
        label: t('tariffs.property.minimal_cost'),
        value: getTransferMinimalCost(transferDetails),
        unit: currencySign,
      },
      {
        label: t('tariffs.property.landing'),
        value: getTransferLandingCost(transferDetails),
        unit: currencySign,
      },
      {
        label: t('tariffs.property.included_distance'),
        value: getTransferIncludedDistance(transferDetails),
        unit: t('tariffs.units.distance'),
      },
      {
        label: t('tariffs.property.included_time'),
        value: getTransferIncludedTime(transferDetails),
        unit: t('tariffs.units.time'),
      },
      {
        label: t('tariffs.property.free_waiting'),
        value: getTransferIncludedWaiting(transferDetails),
        unit: t('tariffs.units.time'),
      },
      getPaidWaiting(
        {
          waiting_price: transferDetails.price.waiting_price,
          waiting_price_type: 'per_minute',
        },
        currencySign,
        t,
      ),
    ])
  }, [currencySign, t, transferDetails])

  return <DetailsList items={items} title={title} />
}

export default TransferPickup
